import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { NO, YES, NONE, VALUE, UNLIMITED } from "const"
import {
    StoreType,
    ChangePackageSettings,
    setPackageSettings,
} from "client/store"
import {
    Collapse,
    PageForm,
    FormGroup,
    Label,
    RadioButton,
    Input,
} from "client/components"

const Rrs = () => {
    const settings = useSelector((state: StoreType) => state.package.packageSettings)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)

    const onChange = (newSettings: ChangePackageSettings) => {
        dispatch(setPackageSettings(newSettings))
    }

    const {
        rrsRiskSpaceModuleAccess,
        rrsRiskSpaceTemplates,
        rrsRiskSpaceTemplatesValue,
    } = settings

    return (
        <Collapse
            show={show}
            title={lang.riskSpace}
            onCollapse={() => setShow(!show)}
        >
            <PageForm>
                <FormGroup>
                    <Label>{lang.riskSpaceModuleAccess}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={rrsRiskSpaceModuleAccess === NO}
                            onChange={() => onChange({ rrsRiskSpaceModuleAccess: NO })}
                            title={lang.no}
                        />
                        <RadioButton
                            checked={rrsRiskSpaceModuleAccess === YES}
                            onChange={() => onChange({ rrsRiskSpaceModuleAccess: YES })}
                            title={lang.yes}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.riskSpaceTemplates}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={rrsRiskSpaceTemplates === NONE}
                            onChange={() => onChange({ rrsRiskSpaceTemplates: NONE })}
                            title={lang.none}
                        />
                        <RadioButton
                            checked={rrsRiskSpaceTemplates === VALUE}
                            onChange={() => onChange({ rrsRiskSpaceTemplates: VALUE })}
                            title={(
                                <Input
                                    type="text"
                                    value={rrsRiskSpaceTemplatesValue}
                                    onChange={(e) => onChange({
                                        rrsRiskSpaceTemplatesValue: parseInt(e.target.value, 10) || 0,
                                    })}
                                />
                            )}
                        />
                        <RadioButton
                            checked={rrsRiskSpaceTemplates === UNLIMITED}
                            onChange={() => onChange({ rrsRiskSpaceTemplates: UNLIMITED })}
                            title={lang.unlimited}
                        />
                    </FormGroup>
                </FormGroup>
            </PageForm>
        </Collapse>
    )
}
export default Rrs
